import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';
import blue from '../../assets/icons/stonks_blue.svg';
import green from '../../assets/icons/stonks_green.svg';
import orange from '../../assets/icons/stonks_orange.svg';

const getIcon = (name) => {
    switch (name) {
    case 'НСЖ':
        return blue;
    case 'ИСЖ':
        return green;
    case 'ПДС':
        return orange;
    default:
        return null;
    }
};

const getHeaderStyle = (name) => {
    switch (name) {
    case 'НСЖ':
        return styles.CardHeaderTitle_Blue;
    case 'ИСЖ':
        return styles.CardHeaderTitle_Green;
    case 'ПДС':
        return styles.CardHeaderTitle_Orange;
    default:
        return null;
    }
};

const getLabel = (name) => {
    switch (name) {
    case 'ПДС':
        return 'Размер первого сберегательного взноса';
    default:
        return 'Размер премии';
    }
};

const BonusCard = ({ data: { name, bonus } }) => (
    <div className={styles.BonusCard}>
        <div className={styles.CardHeader}>
            <div className={cn(styles.CardHeaderTitle, getHeaderStyle(name))}>
                {name}
                <img src={getIcon(name)} alt=""/>
            </div>
        </div>
        <div className={styles.Bonus}>
            <div className={styles.BonusSizeLabel}>{getLabel(name)}</div>
            <div className={styles.BonusSize}>{`${bonus.toLocaleString()} ₽`} </div>
        </div>
    </div>
);

export default BonusCard;
